import type { TRuleWithTheme } from '@/styles/theme';

export const pageContainer: TRuleWithTheme = () => ({
    width: '100%',

    min1024: {
        overflow: 'auto',
    },
});

export const contentContainer: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',

    paddingBlock: '2rem',
    paddingInline: '1rem',

    gap: '0.75rem',

    // To prevent the chat button from overlapping the content
    paddingBottom: '8rem',

    min1024: {
        paddingBlock: '3rem',
        paddingInline: '4.25rem',

        gap: '1rem',
    },
});
